import { useContext } from "react";
import { useState } from "react";
import BaseForm from "../../Form/BaseForm";
import Container from "../../Helper/Container";
import FieldInput from "../../Form/Fields/FieldInput";
import FieldPassword from "../../Form/Fields/FieldPassword";
import MarginChildren from "../../Helper/MarginChildren";
import Page from "../../Helper/Page";
import SubmitButton from "../../Buttons/SubmitButton";
import translate from "../../../Utils/translate";
import usePrompt from "../../../Hooks/usePrompt";
import UserContextProvider from "../../../Context/UserContext";

const Login = ({ setAuthState }) => {
  const [errorId, setErrorId] = useState();
  const { login } = useContext(UserContextProvider);
  const { createError, clearPrompt } = usePrompt();

  const handleLogin = async (event, values) => {
    try {
      await login(values);
      clearPrompt(errorId);
    } catch (error) {
      const errorId = createError(error);
      setErrorId(errorId);
    }
  };

  return (
    <Page>
      <Container className="flex flex-col h-full m-auto md:max-w-screen-sm">
        <div className="flex justify-center">
          <h1 className="my-16 font-semibold text-3xl">{translate("pages.login.header")}</h1>
        </div>

        <BaseForm className="flex-grow flex flex-col justify-between" onSubmit={handleLogin}>
          <MarginChildren>
            <FieldInput placeholder={translate("forms.username.placeholder")} name="username" required={true} />
            <FieldPassword name="password" required={true} />
          </MarginChildren>

          <footer>
            <p className="w-fit m-auto mb-default text-sm">
              {translate("pages.login.footer.cta")}{" "}
              <span
                className=" text-theme-accent font-bold underline cursor-pointer"
                onClick={() => setAuthState("register")}
              >
                {translate("pages.login.footer.message")}
              </span>
            </p>
            <SubmitButton text={translate("forms.buttons.login")} />
          </footer>
        </BaseForm>
      </Container>
    </Page>
  );
};

export default Login;
